$(function () {
    "use strict";

    $(document).on('ready', function () {
        var $toLink = $('span.js-to-link');

        $toLink.each(function () {
            var $currentEl = $(this);
            var attributes = _(this.attributes).map(function (attr) {
                return [ attr.name, attr.value ];
            });
            var $newEl = $('<a>', _.object(attributes));
            $newEl.removeClass('js-to-link');
            $currentEl.wrap($newEl);
            $currentEl.contents().unwrap();
        });
    });
});